import { Navigate, useLocation } from "react-router-dom";

import Sidebar from "./Sidebar";
import storage from "../../helpers/storage";
import { currentPath, loginUrlFor } from "../../helpers/redirect";

/**
 * Every dashboard page sits inside this.
 *
 * It now checks for a session before rendering. Without that, opening a
 * dashboard link while signed out rendered the page, fired requests that
 * came back 401, and bounced to the login — losing the page you asked for
 * on the way. The destination is handed to the login instead, which
 * returns to it.
 */
const DashboardLayout = ({ Component, header, text }) => {
  const location = useLocation();

  if (!storage.getToken()) {
    return <Navigate to={loginUrlFor(currentPath(location))} replace />;
  }

  return (
    <div className="flex h-screen">
      <Sidebar />

      <main className={`pl-[260px] w-screen h-screen dashboard`}>
        <div className={`w-full h-full comp`}>
          <div className="pt-20 h-full bg-white px-10">
            <Component />
          </div>
        </div>
      </main>
    </div>
  );
};

export default DashboardLayout;
